/** EN translations for Les Aiguilles Blanches */
const en: Record<string, string> = {
  subtitle: "Snow Groomer Simulation",
  startGame: "Start Game",
  resumeGame: "Resume",
  newGame: "New Game",
  // UNUSED continue: "Continue",
  settings: "Settings",
  controls: "Controls",
  changelog: "What's New",
  howToPlay: "How to Play",
  fullscreen: "Fullscreen",
  fullscreenHint: "Press F for fullscreen",
  exitFullscreen: "Exit Fullscreen",
  back: "Back",
  backToGame: "Back to Game",
  // UNUSED loading: "Loading...",
  inputKeyboard: "✓ Keyboard detected",
  inputKeyboardOff: "✗ No keyboard",
  inputTouch: "✓ Touchscreen detected",
  inputTouchOff: "✗ No touchscreen detected",
  inputGamepad: "✓ Gamepad connected",
  inputGamepadOff: "✗ No gamepad",
  updateAvailable: "New version available — tap to reload",
  madeIn: "Made with ❄️ in Savoie",
  feedback: "Send feedback",
  on: "✓ ON",
  off: "✗ OFF",
  zoneClosed: "🚫 ZONE CLOSED",
  
  // Settings
  language: "Language",
  accessibility: "Accessibility",
  highContrast: "High Contrast",
  reducedMotion: "Reduced Motion",
  showFps: "Show FPS counter",
  showDebug: "Debug Overlay",
  skiStyle: "Style",
  skiTricks: "Tricks",
  skiBestCombo: "Best combo",
  quitGame: "Quit Game",
  display: "Display",
  displayWindowed: "Windowed",
  displayFullscreen: "Fullscreen",
  displayBorderless: "Borderless",
  colorblindMode: "Colorblind",
  none: "None",
  deuteranopia: "Deutan.",
  protanopia: "Protan.",
  tritanopia: "Tritan.",
  // UNUSED move: "Move",
  moveUp: "Up",
  moveDown: "Down",
  moveLeft: "Left",
  moveRight: "Right",
  groom: "Groom",
  winch: "Winch",
  pause: "Pause",
  keyboard: "Keyboard",
  clickToRebind: "Click to rebind",
  pressKey: "Press a key...",
  pressGamepadButton: "Press a gamepad button...",
  noGamepad: "No gamepad connected",
  gamepadButtons: "Gamepad",
  saved: "Saved!",
  resetControls: "Reset All",
  controlsReset: "Controls reset!",
  movementSensitivity: "Sensitivity",
  keyboardLayout: "Layout",
  customBindings: "Custom",
  // UNUSED gamepadSupported: "Gamepad OK",
  touch: "Touch",
  // UNUSED touchSupported: "Touch OK",
  noGamepadConnected: "No gamepad connected",
  gamepadDiagnostic: "Controller Test",
  connectGamepadDiag: "Connect a controller to test",
  gamepadDiagButtons: "Buttons",
  gamepadDiagSticks: "Sticks",
  gamepadDiagTriggers: "Triggers",

  // Audio
  audio: "Audio",
  masterVolume: "Master Volume",
  musicVolume: "Music",
  sfxVolume: "Sound Effects",
  engineVolume: "Engine",
  voiceVolume: "Voice",
  ambienceVolume: "Ambience",
  mute: "Mute",

  backgroundAudio: "Background Audio",
  // Bonus
  bonus: "Bonus",
  skiMode: "Descent Mode",
  ski: "Ski",
  snowboard: "Snowboard",
  random: "Random",
  skiIt: "Ski it!",
  rideIt: "Ride it!",
  skiAgain: "Ski Again!",
  rideAgain: "Ride Again!",
  skiRunSpeed: "Speed",
  skiRunTime: "Time",
  skiRunGates: "Gates",
  
  // How to Play hints
  howToPlayMove: "{keys} or Arrows to move",
  howToPlayMoveTouch: "Use the virtual D-pad",
  howToPlayMoveGamepad: "Left stick or D-pad to move",
  howToPlayMoveHybrid: "{keys}/Arrows or touch D-pad",
  howToPlayGroom: "{groomKey} to groom snow",
  howToPlayGroomTouch: "Hold the groom button",
  howToPlayGroomGamepad: "to groom snow",
  howToPlayGroomHybrid: "{groomKey} or hold the groom button",
  howToPlayFuel: "Watch your fuel and stamina!",
  howToPlayWinch: "{winchKey} near an anchor post to use winch",
  howToPlayWinchTouch: "Hold the winch button near an anchor post",
  howToPlayWinchGamepad: "near an anchor post to use winch",
  howToPlayWinchHybrid: "{winchKey} or hold the winch button near an anchor post",
  
  // Winch
  winchSnapped: "💥 Cable snapped!",
  winchAttached: "🔗 Winch attached! Hold {winchKey} for assistance.",
  winchActive: "WINCH",
  // UNUSED winchHint: "Press {winchKey} near a numbered anchor post to use winch",
  // UNUSED winchHintTouch: "Hold 🔗 for winch",
  // UNUSED accessPath: "Service Road",
  // UNUSED toPiste: "To the piste",
  
  // Taunts - Cliff falls (emphasize the dramatic fall, insurance headaches, rescue hassle)
  tauntCliff1: "9 tons into the ravine. Insurance will love this.",
  tauntCliff2: "Jean-Pierre said 'not too close to the edge!' Remember?",
  tauntCliff3: "Ski patrol is coming down with ropes. Again.",
  tauntCliff4: "Marie cancels your raclette reservation for tonight.",
  tauntCliff5: "Thierry is already calculating repair costs...",
  
  // Taunts - Fuel empty (emphasize planning failure, team disappointment)
  tauntFuel1: "The gauge was on red for 10 minutes. What were you looking at?",
  tauntFuel2: "Émilie wrote 'REFUEL' in capital letters on the board.",
  tauntFuel3: "Even diesel has limits. So do you, apparently.",
  tauntFuel4: "Jean-Pierre sighs. He's sending Thierry with a jerry can.",
  tauntFuel5: "Sun's rising. Piste isn't groomed. Skiers are arriving.",
  
  // Taunts - Time limit (emphasize consequences for skiers and competition)
  tauntTime1: "First chairlift in 3... 2... 1... Missed it.",
  tauntTime2: "Skiers discover your piste. Bumpy. Icy. Magnificent.",
  tauntTime3: "Jean-Pierre looks at his watch, then at you, then his watch.",
  tauntTime4: "FIS is asking why the slalom is on soup.",
  tauntTime5: "You hear ski instructors explaining to clients why it's 'not their fault'.",
  
  // UNUSED paused: "Paused",
  resume: "Resume",
  quitToMenu: "Quit to Menu",
  levelComplete: "Run Complete!",
  levelFailed: "Run Failed",
  tryAgain: "Try Again",
  coverage: "Coverage",
  time: "Time",
  // UNUSED rating: "Rating",
  nextLevel: "Next Run",
  // UNUSED replay: "Replay",
  // UNUSED pressContinue: "Press Space or tap to continue",
  pauseTitle: "⏸️ Paused",
  restart: "Restart",
  skipRun: "Skip Run",
  newRun: "New Run",
  quit: "Quit",
  menu: "Menu",
  levelSelect: "Trail Map",
  locked: "Closed",
   completeToUnlock: "Complete {name} to unlock",
  // UNUSED target: "Target",
  tutorial: "Ski School",
  timeUsed: "Time Used",
  excellent: "Excellent!",
  good: "Well done!",
  passed: "Passed",
  bonusFuel: "Fuel used",
  bonusFlawless: "First try",
  bonusSpeed: "Time",
  bonusWinch: "Winch uses",
  bonusExplore: "Roads explored",
  bonusPrecision: "Grooming quality",
  retry: "Retry",
  gameComplete: "Game Complete!",
  viewCredits: "View Credits",
  creditsTitle: "Congratulations!",
  creditsSubtitle: "You have mastered Les Aiguilles Blanches",
  creditsCreatedBy: "Created by",
  creditsDevelopedWith: "Developed with",
  creditsArtDirection: "Art Direction",
  creditsRetroInspiration: "A nod to retro classics like SkiFree",
  creditsInspiredBy: "Inspired by",
  creditsGroomers: "The snow groomers of Savoie",
  creditsDedication: "For the night crews who prepare the slopes while we sleep",
  creditsThanks: "Thanks for playing!",
  creditsSeeYou: "See you on the slopes!",
  creditsLine: "Come on, kid. The sun is rising. The mountain is ready.",
  playAgain: "Play Again",
  skipCredits: "Press any key to skip",
  
  // Tutorial - Full walkthrough
  tutorialName: "Tutorial - First Steps",
  tutorialTask: "Learn grooming basics",
  prologueLine: "4 AM. The mountain is yours. Let's get to work.",
  prologueSkip: "Press any key to continue",
  tutorialIntro: "Welcome to Les Aiguilles Blanches!",
  skipTutorial: "⏭️ Skipping tutorial… Tap to replay instead.",
  skipTutorialGamepad: "⏭️ Skipping tutorial… Press any button to replay.",
  tutorialWelcome: "🏔️ I'm Jean-Pierre, head groomer. Drive around the piste — use {keys} or ↑↓←→.",
  tutorialWelcomeTouch: "🏔️ I'm Jean-Pierre, head groomer. Drive around the piste — use the D-pad on the left.",
  tutorialWelcomeGamepad: "🏔️ I'm Jean-Pierre, head groomer. Drive around the piste — use the left stick or D-pad.",
  // UNUSED   tutorialControls: "🎮 To move the groomer, use {keys} or the arrow keys ↑↓←→.",
  // UNUSED   tutorialControlsTouch: "🎮 To move the groomer, use the D-pad ◀▲▼▶ on the left.",
  // UNUSED   tutorialControlsGamepad: "🎮 To move the groomer, use the left stick or D-pad.",
  // UNUSED   tutorialMove: "➡️ Go on, try it! Move around the piste — all the white snow needs grooming.",
  // UNUSED   tutorialGroomIntro: "✅ Nice! Now let's learn to groom.",
  tutorialGroomAction: "❄️ Hold {groomKey} while driving to groom the snow. It'll smooth right out.",
  tutorialGroomActionTouch: "❄️ Hold the groom button on the right while driving to groom the snow.",
  tutorialGroomActionGamepad: "❄️ Hold {groomKey} while driving to groom the snow. It'll smooth right out.",
  tutorialGroomGoal: "📊 That's it! Groom at least 60% before the lifts open. Skiers are coming!",
  // UNUSED   tutorialCoverage: "📊 See? The snow becomes smoother! Keep grooming the piste.",
  // UNUSED   tutorialHUD: "📈 Check the dashboard up top: the red bar is fuel, green is stamina, white is coverage. The clock's ticking!",
  // UNUSED   tutorialGoal: "🎯 You need to groom at least 60% of the piste before opening. Skiers are coming!",
  // UNUSED tutorialFuel: "⛽ Careful — driving burns fuel. On missions, stop by the fuel station.",
  tutorialComplete: "🏆 Well done! You've mastered the basics. Ready for your first real mission on the Green Piste?",
  
  level_marmottesName: "Green Piste - Les Marmottes",
  level_marmottesTask: "Groom the beginner slope",
  level_chamoisName: "Blue Piste - Le Chamois",
  level_chamoisTask: "Groom efficiently before opening",
  level_airZoneName: "Snowpark - Air Zone",
  level_airZoneTask: "Prepare freestyle features",
  level_aigleName: "Red Piste - L'Aigle",
  level_aigleTask: "Groom steep terrain, manage fuel",
  level_glacierName: "Red Piste - Le Glacier",
  level_glacierTask: "Learn to use the winch on steep slopes",
  level_tubeName: "Half-pipe - Le Tube",
  level_tubeTask: "Maintain the half-pipe for competition",
  level_verticaleName: "Black Piste - La Verticale",
  level_verticaleTask: "Night operation with winch",
  level_colDangereuxName: "Avalanche Zone - Col Dangereux",
  level_colDangereuxTask: "Prepare the high-risk zone",
  level_tempeteName: "Storm - Recovery",
  level_tempeteTask: "Clear pistes after the storm",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - FIS Finale",
  level_coupeDesAiguillesTask: "Prepare all pistes for the competition",
  
  // Hazards
  cliffFall: "⚠️ WARNING! You fell off the cliff! Mission failed.",
  fuelEmpty: "⛽ OUT OF FUEL! Not a drop of diesel left...",
  // UNUSED avalancheZone: "AVALANCHE ZONE",
  riskLevelHigh: "HIGH",
  avalancheWarning: "⚠️ DANGER! Snowpack is unstable! Leave the zone!",
  avalancheTrigger: "🏔️💨 AVALANCHE TRIGGERED! No escape!",
  steepWarning: "⚠️ STEEP SLOPE! Use the winch ({winchKey}) or you'll slide!",
  steepWarningNoWinch: "⚠️ STEEP SLOPE! Slow down and use service roads to get around!",
  tumble: "🔄 ROLLOVER! The groomer tumbled on the slope!",
  
  // Taunts - Tumble/Rollover (emphasize winch lesson, expensive damage)
  tauntTumble1: "The winch isn't decorative. It's for slopes like this.",
  tauntTumble2: "Thierry stares at the damage. Says nothing. That's worse.",
  tauntTumble3: "Jean-Pierre showed you how to anchor. Were you asleep?",
  tauntTumble4: "A PistenBully costs €400,000. Well, it did.",
  tauntTumble5: "The slope seemed manageable? The groomer disagreed.",
  featureDestroyedKicker: 'You drove onto a park feature! The kicker is ruined.',
  featureDestroyedRail: 'You drove onto a park feature! The rail is wrecked.',
  tauntFeature1: 'That feature took three hours to build. You flattened it in three seconds.',
  tauntFeature2: 'Émilie is going to have words with you about that park module.',
  tauntFeature3: 'The park crew just watched you destroy their masterpiece.',
  tauntFeature4: 'Features are for skiers, not for groomers. Drive around them!',
  tauntFeature5: 'One less feature for tomorrow\'s competition.',
  bonusPipeMastery: 'Halfpipe mastery',
  
  // Taunts - Avalanche (emphasize danger, respect for mountain)
  tauntAvalanche1: "The mountain rarely forgives. It didn't forgive.",
  tauntAvalanche2: "Météo France said risk level 4. Did you read it?",
  tauntAvalanche3: "Ski patrol will find the groomer in spring. Maybe.",
  tauntAvalanche4: "Marie hears the radio alert. She already knows it's you.",
  tauntAvalanche5: "Ski patrol had secured that sector. You un-secured it.",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "Classic yard sale. Gear everywhere, dignity nowhere.",
  tauntSkiWipeout2: "The cliff didn't care about your ski technique.",
  tauntSkiWipeout3: "Ski patrol is already laughing. They saw the whole thing.",
  tauntSkiWipeout4: "That's what you get for skiing a piste YOU groomed.",
  tauntSkiWipeout5: "Even the bouquetins winced at that landing.",
  
  jeanPierreIntro: "Good work on the tutorial, kid. Now it's for real — the Green Piste, with a timer and fuel to manage.",
  level_marmottesMid: "See that glow on the peaks? First light. Best part of this job — just you, the machine, and the mountain waking up.",
  level_chamoisIntro: "Hey, I'm Émilie — JP's putting you on the blue. Come on, show you can do more than lay corduroy on the green.",
  level_airZoneIntro: "The snowpark's MY turf — we're gonna set up something sick! Every feature needs to be dialed, the riders are counting on us.",
  level_aigleIntro: "L'Aigle is serious. Watch your fuel. Access paths let you drive back up — look for the yellow and black striped poles.",
  level_glacierIntro: "Hey, I'm Thierry — head of safety. Le Glacier is steep. I've checked every anchor. Press {winchKey} near a post to attach the winch — and please, don't let go.",
  level_glacierIntroTouch: "Hey, I'm Thierry — head of safety. Le Glacier is steep. I've checked every anchor. Tap the winch button near a post to attach — and please, don't let go.",
  level_tubeIntro: "Tomorrow's the contest at The Tube! I want clean walls, a sharp lip, and zero bumps.",
  level_verticaleIntro: "Night op on La Verticale: steep slope, dangerous edges. Winch is mandatory — use the 3 anchors and stay on line.",
  level_colDangereuxIntro: "High avalanche risk on the Col — avalanche safety protocol is active. Stay out of loaded areas and respect the boundaries.",
  level_tempeteIntro: "Storm's passed. Grab a vin chaud — this'll take a while!",
  level_coupeDesAiguillesIntro: "This is the big night. FIS inspects tomorrow. Every piste must be perfect — show me what you've learned.",
  marieWelcome: "Come warm up at Chez Marie. A good tartiflette!",
  marieIntro: "Hey there! I'm Marie — I run the restaurant up top. Stop by anytime, a hot meal does wonders out here!",
  
  // Changelog
  changelog_20260219_date: "February 19, 2026",
  changelog_20260219: "🎬 Cold-open prologue for new players\n📖 Streamlined tutorial\n🌦️ Random menu weather\n🔗 Shareable daily runs\n🎥 Cinematic credits scene",
  changelog_20260222_date: "February 22, 2026",
  changelog_20260222: "🚩 Slalom gate rebalance\n💬 Feedback button",
  changelog_20260223_date: "February 23, 2026",
  changelog_20260223: "📲 Install on your device for offline play",
  changelog_20260220_date: "February 20, 2026",
  changelog_20260220: "🗺️ Trail map\n🎿 Ski resort terminology",
  changelog_20260217_date: "February 17, 2026",
  changelog_20260217: "🏔️ Seven piste shapes\n🎯 Run generation variety\n⚡ Smoother ski runs",
  changelog_20260216_date: "February 16, 2026",
  changelog_20260216: "🎲 Daily Runs mode",
  changelog_20260215_date: "February 15, 2026",
  changelog_20260215: "⚡ Night rendering overhaul\n📱 Ski mode touch buttons\n⌨️ Keyboard layout detection",
  changelog_20260214_date: "February 14, 2026",
  changelog_20260214: "🎪 Trick scoring & combos\n🏂 Tuck & halfpipe physics\n👁️ Better piste contrast\n📱 Touch auto-groom on winch\n♿ High contrast mode",
  changelog_20260213_date: "February 13, 2026",
  changelog_20260213: "🚩 Slalom gates\n🏔️ Ski jumps\n⚡ Smoother performance\n🎹 Nocturne piano music\n🔊 Engine volume control",
  changelog_20260212_date: "February 12, 2026",
  changelog_20260212: "📋 Trail map\n🔗 Breakable winch cable\n🕹️ Controller diagnostics\n🍽️ Marie's kitchen\n❄️ Frost exposure",
  changelog_20260211_date: "February 11, 2026",
changelog_20260211: "⛷️ Ski run after grooming\n🎯 Grooming quality\n🏔️ Color-coded steep zones\n🏗️ Terrain park and tricks",
  changelog_20260210_date: "February 10, 2026",
  changelog_20260210: "🎵 Music and sound effects\n🔈 Volume settings\n⏱️ Auto-calibrated run times\n⏭️ Skip tutorial option\n🏔️ Avalanche zone redesign",
  changelog_20260209_date: "February 9, 2026",
  changelog_20260209: "🏔️ Alpine win/fail screens\n❄️ Storm snow accumulation\n🏆 Flawless bonus\n🔊 Weather and wildlife ambience",
  changelog_20260208_date: "February 8, 2026",
  changelog_20260208: "📊 Redesigned dashboard\n🏔️ Le Glacier and Coupe des Aiguilles\n🦅 Alpine wildlife\n🎨 Character portraits\n🎮 Keyboard & gamepad navigation",
  changelog_20260207_date: "February 7, 2026",
  changelog_20260207: "🎨 Retro UI\n🎯 Bonus objectives\n🕹️ Gamepad button rebinding\n🎮 Gamepad menu navigation",
  changelog_20260206_date: "February 6, 2026",
  changelog_20260206: "🛤️ Traversable cat tracks\n🕹️ Virtual joystick\n🌍 5 complete languages",
  changelog_20260205_date: "February 5, 2026",
  changelog_20260205: "🏔️ Rocky cliffs\n🌙 Night headlights\n🔗 Winch mechanics\n⌨️ Keyboard navigation",
  changelog_20260204_date: "February 4, 2026",
  changelog_20260204: "🎮 Gamepad support\n📱 Touch controls\n💪 Stamina\n💾 Save progress\n♿ Accessibility",
  changelog_20260203_date: "February 3, 2026",
  changelog_20260203: "🚜 Launch: 9 runs, ski school\n❄️ Grooming, fuel, avalanches\n🏆 Credits and progression",
  // Key names
  key_space: "SPACE",
  key_shift: "SHIFT",
  key_ctrl: "CTRL",
  key_alt: "ALT",
  key_enter: "ENTER",
  key_tab: "TAB",
  key_esc: "ESC",
  key_del: "DEL",
  dailyRuns: "Daily Runs",
  dailyRuns_dailyShift: "Daily Shift",
  dailyRuns_randomRun: "Random Run",
  dailyRuns_rank: "Rank",
  dailyRuns_seed: "Seed",
  // UNUSED   dailyRuns_start: "Start Contract",
  dailyRuns_locked: "Complete all runs to unlock",
  dailyRuns_lockedShared: "Complete all runs to unlock Daily Runs and play this shared piste",
  // UNUSED   dailyRun_levelName: "Contract",
  dailyRun_levelTask: "Groom the piste to target coverage",
  dailyRuns_briefing: "Briefing",
  dailyRuns_target: "Target",
  dailyRuns_timeLimit: "Time",
  dailyRuns_weather_clear: "Clear skies",
  dailyRuns_weather_light_snow: "Light snowfall",
  dailyRuns_weather_storm: "Storm conditions",
  dailyRuns_night: "Night shift",
  dailyRuns_day: "Day shift",
  rank_green: "Green",
  rank_blue: "Blue",
  rank_red: "Red",
  rank_black: "Black",
  rank_park: "Park",
  share: "Share",
  copied: "Link copied!",
  playSharedSeed: "Shared Run",
  dailyRunBriefingJP: "This piste needs prep before the lifts open. Get it done.",
  dailyRunBriefingThierry: "Watch yourself out there — steep sections and unstable snow. Stay sharp.",
  dailyRunBriefingMarie: "It's going to be a cold one tonight. Come warm up at the restaurant if you need to.",
  dailyRunBriefingEmilie: "Another day, another piste. Try to beat my time on this one!",
};

export default en;
